<template>
    <ul :class="[prefixCls + '-list']">
        <li :class="fileCls(file)" @click="handleClick(file)">
            <span @click="handlePreview(file)">
                <Icon :type="format(file)"></Icon>
                {{ file.name }}
                <Icon v-show="file.status == 'error' || file.status == 'fail'" type="md-close-circle" style="color: red" />
            </span>
            <Icon
                v-if="showCloseBtn"
                type="ios-close"
                :class="[prefixCls + '-list-remove']"
                @click.native="handleRemove(file)"
            ></Icon>
            <transition name="fade">
                <Progress
                    v-if="file.showProgress"
                    :stroke-width="2"
                    :percent="parsePercentage(file.percentage)"
                    :status="file.status === 'finished' && file.showProgress ? 'success' : 'normal'"
                ></Progress>
            </transition>
        </li>
    </ul>
</template>
<script>
const prefixCls = "ivu-upload";

export default {
    name: "UploadList",
    props: {
        file: {
            type: Object,
            default() {
                return {};
            }
        },
        showCloseBtn: {
            type: Boolean
        }
    },
    data() {
        return {
            prefixCls: prefixCls
        };
    },
    methods: {
        fileCls(file) {
            return [
                `${prefixCls}-list-file`,
                {
                    [`${prefixCls}-list-file-finish`]:
                        file.status === "finished"
                }
            ];
        },
        handleClick(file) {
            this.$emit("on-file-click", file);
        },
        handlePreview(file) {
            this.$emit("on-file-preview", file);
        },
        handleRemove(file) {
            this.$emit("on-file-remove", file);
        },
        format(file) {
            const format =
                (file.name || '')
                    .split(".")
                    .pop()
                    .toLocaleLowerCase() || "";
            let type = "ios-document-outline";

            if (
                ["gif", "jpg", "jpeg", "png", "bmp", "webp"].indexOf(format) >
                -1
            ) {
                type = "ios-image";
            }
            if (
                [
                    "mp4",
                    "m3u8",
                    "rmvb",
                    "avi",
                    "swf",
                    "3gp",
                    "mkv",
                    "flv"
                ].indexOf(format) > -1
            ) {
                type = "ios-film";
            }
            if (
                ["mp3", "wav", "wma", "ogg", "aac", "flac"].indexOf(format) > -1
            ) {
                type = "ios-musical-notes";
            }
            if (
                ["doc", "txt", "docx", "pages", "epub", "pdf"].indexOf(format) >
                -1
            ) {
                type = "md-document";
            }
            if (["numbers", "csv", "xls", "xlsx"].indexOf(format) > -1) {
                type = "ios-stats";
            }
            if (["keynote", "ppt", "pptx"].indexOf(format) > -1) {
                type = "ios-videocam";
            }

            return type;
        },
        parsePercentage(val) {
            return parseInt(val, 10);
        }
    }
};
</script>